module.exports = __webpack_public_path__ + "img/p3_11.88e1d616.png";